import request from '@/utils/request'

// 登录 - application/json
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: {
      principal: data.principal,
      credentials: data.credentials,
      smscode: data.smscode
    }
  })
}

// 发送登录短信验证码（后台登录需要短信验证码；type=2 表示登录）
export function sendSmsCode(data) {
  return request({
    url: '/api/sms/smscode',
    method: 'post',
    params: { principal: data.principal, type: 2 }
  })
}

// 获取当前用户信息
export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get'
  })
}

// 退出登录
export function logout() {
  return request({
    url: '/api/home/logout',
    method: 'get'
  })
}
